<template>
  <div>
    <b-row>
      <b-col cols="6">{{ $t('general.supplier') }}</b-col>
      <b-col cols="6">{{ $t('general.ek_short') }}</b-col>
    </b-row>
    
    <div class="mb-3 mt-1">
      <b-row class="supplierRow" v-for="(purchasePrice,index) in purchasePrices" v-bind:key="purchasePrice.id">
        <b-row>
          <b-col cols="6"><span>{{ wineSupplierText(purchasePrice.wineSupplier.data) }}</span></b-col>
          <b-col cols="6">
            <span class="smallText">{{ $t('general.netPrice') }}: </span>
            <span class="currency">{{ purchasePrice.price.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2 }) }} {{ currency }}</span>
            <span class="smallText">{{ $t('general.grossPrice') }}: </span>
            <span class="currency">{{ getGrossPrice(purchasePrice.price) }} {{ currency }}</span>
          </b-col>
        </b-row>

        <div v-if="hasWineSupplierArticleInfo(purchasePrice)" class="spacer xs" />

        <b-row v-if="hasWineSupplierArticleInfo(purchasePrice)">
          <b-col cols="6">
            <span class="smallText">{{ $t('general.wineSupplierArticleNumber') }}: </span>
          </b-col>
           <b-col cols="6">
            <span class="smallText">{{ purchasePrice.wineSupplierArticleNumber }}</span>
          </b-col>
        </b-row>

        <b-row v-if="hasWineSupplierArticleInfo(purchasePrice)">
          <b-col cols="6">
            <span class="smallText">{{ $t('general.wineSupplierArticleName') }}: </span>
          </b-col>
          <b-col cols="6">
            <span class="smallText">{{ purchasePrice.wineSupplierArticleName}}</span>
          </b-col>
        </b-row>

        <div v-if="index < purchasePrices.length - 1" class="spacer s" />

      </b-row>

    </div>
  </div>
</template>

<script>

import { getGrossPrice, getWineSupplierText } from '@/utils/functions'

export default {
  name: 'PurchasePrices',
  props: {
    venueSupplierOptions: Array,
    purchasePrices: Array,
    currency: String
  },
  methods: {
    getGrossPrice,
    wineSupplierText(wineSupplier) {
      const generalText = this.$t('general.dropdownText')
      return getWineSupplierText(generalText, wineSupplier, this.venueSupplierOptions)
    },
    hasWineSupplierArticleInfo(purchasePrice) {
      return purchasePrice.wineSupplierArticleNumber || purchasePrice.wineSupplierArticleName
    }
  }
}

</script>